import { DisabledPrompt, useRoute, useStateManager } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView, WidgetContainer, WidgetView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { PrimaryButton, SecondaryButton, UIPhoneNumberWithCodeInput } from "components/ui";
import React from "react";
import "./styles.css";
import "./mobile.css";


/**
 * @function PhoneNumberWidget
 * @return {React.Component}
 * @exported true
 * @description The main widget used in the PhoneNumberWithCodePage. 
 */
export default function PhoneNumberWidget(props) {
  const { data, onChange } = useStateManager();
  const navigate = useRoute();
  const _onChange = onChange ?? (() => {});

  return (
    <WidgetContainer className="phone-number-widget">
      <WidgetView text="Contact Information">
        <FormContainer className="phone-number-form">
          <FormRowView className="home-phone-row-view" text="Home Phone">
            <UIPhoneNumberWithCodeInput codeID={ data.homePhone.codeID } phoneNumber={ data.homePhone.phoneNumber } dataPoint="test_1" onChange={ _onChange("homePhone") } />
          </FormRowView>
          <FormRowView className="mobile-phone-row-view" text="Mobile Phone">
            <UIPhoneNumberWithCodeInput codeID={ data.mobilePhone.codeID } phoneNumber={ data.mobilePhone.phoneNumber } dataPoint="test_2" onChange={ _onChange("mobilePhone") } />
          </FormRowView>
          <FormRowView className="work-phone-row-view" text="Work Phone">
            <UIPhoneNumberWithCodeInput codeID={ data.workPhone.codeID } phoneNumber={ data.workPhone.phoneNumber } onChange={ _onChange("workPhone") } />
          </FormRowView>
          <FormButtonRow>
            <SecondaryButton text="Cancel" onClick={() => { navigate("/profile") }} />
            <DisabledPrompt>
              <PrimaryButton text="Update" />
            </DisabledPrompt>
          </FormButtonRow>
        </FormContainer>
      </WidgetView>
    </WidgetContainer>
  )
}